import React from 'react';
import KnowledgeComponent from './KnowledgeComponent';

const DomainStores = () => {
  return <KnowledgeComponent mainView="domainStores" />;
};

export default DomainStores;
